import { Switch, FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 50, 
  height: 25,
  padding: 0,
  "& .MuiFormControlLabel-root": {
    marginRight: 0,
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(26px)", 
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        border: 0,
        // iOS accent convention — the on-state uses the tenant brand color
        // so the switch reads as "active". White thumb sits in front of the
        // tinted track, so brand contrast is not a concern.
        backgroundColor: theme.palette.customPrimary.main,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 20, 
    height: 20, 
    backgroundColor: "white",
  },
  "& .MuiSwitch-track": {
    borderRadius: 30 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    width: 50, 
    height: 25, 
    position: "relative", 
  },
}));

const CustomSwitch = ({ onClick, checked, disabled = false }) => {
  return (
    <FormControlLabel
      sx={{
        marginRight: 0,
      }}
      control={
        <IOSSwitch
          checked={checked}
          disabled={disabled}
          onChange={(e) => {
            onClick();
          }}
        />
      }
    />
  );
};

export default CustomSwitch;
